<script>
export default {
    name: 'paginator',
    props:
    {
        items: Object,
        subPageName: String,
        loading: Boolean,
    },
    methods:
    {
        onPage(page)
        {
            this.$router.push({
                name: this.subPageName,
                params: {
                    page: page,
                    sort: this.$route.params.sort,
                    order: this.$route.params.order,
                    search: this.$route.params.search || null,
                }
            })
        },
    }
}
</script>

<template>
    <div class="p-2">
        <nav aria-label="Page navigation example" v-if="items.data && items.data.length != 0 && !loading">
            <ul class="pagination engage-pagination justify-content-center">
                <li class="page-item" v-if="items.current_page - 1 > 0" @click="onPage(items.current_page - 1)">
                    <a class="page-link cp user-none">Previous</a>
                </li>
                <li class="page-item" @click="onPage(n)" v-for="n in items.last_page" :key="n" :class="{'active' : n == items.current_page}">
                    <a class="page-link text-blue cp user-none">{{ n }}</a>
                </li>
                <li class="page-item" v-if="items.current_page + 1 <= items.last_page" @click="onPage(items.current_page + 1)">
                    <a class="page-link cp user-none">Next</a>
                </li>
            </ul>
        </nav>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/elements/Paginator.vue